import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { TitleService } from '@core/services/title.service';

import { ApolloService } from '../../../../services/apollo/apollo.service';
import { ApolloItem } from '../../../../model/apollo-item.model';

import { ApolloRequest } from '../../../../model/apollo-request.model';

@Component({
    selector: 'plugin-apollo-main-section-upload',
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.scss']
})
export class PluginApolloMainSectionUploadComponent implements OnInit, OnDestroy {

    readonly GRAPHIC_COMPARE_MENU = "Compare graphics";
    readonly CONTENT_COMPARE_MENU = "Compare texts";

    public show: boolean;
    public showComparison:boolean = false;
    protected requestStore: ApolloRequest;

    public referenceItem: ApolloItem = null;
    public targetItem: ApolloItem = null;
    public referenceFileId: string;
    public targetFileId: string;

    public buttons: any = { enabled: false,
                            graphic: false,
                            content: false};

    // Subscriptions
    public subscriptionMenu: Subscription;
    protected subscriptionRequest: Subscription;
    public subscriptionTarget: Subscription;
    public subscriptionReference: Subscription;
    public subscriptionRoutes: Subscription;

    // load by hash
    public hashLoad: any = {
        hash: null,
        loading: true,
        referenceLoaded: false,
        targetLoaded: false
    };

    constructor(public apolloSrv: ApolloService, 
        private activatedRoute: ActivatedRoute, 
        private title: TitleService){}

    ngOnInit() {
        this.title.set("Select files - XRay");
        this.subscriptionRequest = this.apolloSrv.selectRequest().subscribe((request: ApolloRequest) => {

            //load files when load by hash
            if(this.hashLoad.hash === request.hash && this.hashLoad.loading == true) {
                this.apolloSrv.loadFile('reference', request.reference.id_file);
                this.apolloSrv.loadFile('target', request.target.id_file);
            }

        });


        this.subscriptionReference = this.apolloSrv.getItemReference().subscribe( reference => {
            this.referenceItem = reference;
            setTimeout(() => this.controlItems(), 10);
            this.hashLoad.referenceLoaded = true;
            this.hashLoadFinished();
        });

        this.subscriptionTarget = this.apolloSrv.getItemTarget().subscribe( target => {
            
            this.targetItem = target;
            setTimeout(() => this.controlItems(), 10);
            this.hashLoad.targetLoaded = true;
            this.hashLoadFinished();
        });

        this.subscriptionMenu = this.apolloSrv.getMenu().subscribe( menu => {
            let compareGraphicLinks = menu.filter( i => { return i.title == this.GRAPHIC_COMPARE_MENU; })
            let compareContentLinks = menu.filter( i => { return i.title == this.CONTENT_COMPARE_MENU; })

            this.buttons.graphic = !compareGraphicLinks[0].disabled;
            this.buttons.content = !compareContentLinks[0].disabled;
        });

        // load query params
        this.subscriptionRoutes = this.activatedRoute.queryParams.subscribe(params => {
            this.referenceFileId = params?.reference;
            this.targetFileId = params?.target;

            // Load files based on URL params
            if (this.referenceFileId) {
                this.apolloSrv.loadFile('reference', this.referenceFileId);
            }

            if (this.targetFileId) {
                this.apolloSrv.loadFile('target', this.targetFileId);
            }
        });

        // loading by hash
        let hash = this.activatedRoute.snapshot.paramMap.get('hash');
        if(hash) {
            this.hashLoad = {
                ...this.hashLoad,
                hash: hash,
                loading: true,
                referenceLoaded: false,
                targetLoaded: false
            };

            this.apolloSrv.loadSavedRequest(hash);
        } else {
            this.hashLoad = {
                ...this.hashLoad,
                loading: false
            }
        }
    }

    ngOnDestroy(){
        this.subscriptionMenu.unsubscribe();
        this.subscriptionRoutes.unsubscribe();
        this.subscriptionReference.unsubscribe();
        this.subscriptionTarget.unsubscribe();
    }

    private hashLoadFinished() {
        this.hashLoad.loading = !(this.hashLoad.referenceLoaded && this.hashLoad.targetLoaded)
    }

    controlItems(){
        if(this.targetItem != null
            && this.targetItem.filters.length > 0
            && this.referenceItem != null
            && this.referenceItem.filters.length > 0){
            this.buttons.enabled = true;

            if(!this.selectedPagesAreNotIgnored())
                this.apolloSrv.deactiveMenuItem(this.GRAPHIC_COMPARE_MENU);
            else
                this.apolloSrv.activeMenuItem(this.GRAPHIC_COMPARE_MENU);

            this.apolloSrv.activeMenuItem(this.CONTENT_COMPARE_MENU);

        } else {
            this.buttons.enabled = false;
        }
    }

    // check if selected pages are not ignored
    protected selectedPagesAreNotIgnored() {
        return !this.targetItem.filters.filter(f => f.type == "ignore" && f.options==true).map(f=>f.page).includes(Number(this.targetItem.page_selected)) &&
            !this.referenceItem.filters.filter(f => f.type == "ignore" && f.options==true).map(f=>f.page).includes(Number(this.referenceItem.page_selected));
    }

}
